import axiosInstance from './axiosConfig';

export const getStagesApi = (tournamentId) =>
  axiosInstance.get('/stages', { params: { tournamentId } });

export const getStageApi = (id) => axiosInstance.get(`/stages/${id}`);

export const createStageApi = (payload) => axiosInstance.post('/stages', payload);

export const updateStageApi = (id, payload) => axiosInstance.put(`/stages/${id}`, payload);

export const deleteStageApi = (id) => axiosInstance.delete(`/stages/${id}`);

// ساخت خودکار جدول حذفی از روی نتایج یک مرحله‌ی گروهی
// stageId = مرحله‌ی مقصد (باید از نوع KNOCKOUT باشد)
// payload = { sourceStageId, qualifiersPerGroup, matchDefaults: { type, gender, ageGroup, date, location, season } }
export const generateKnockoutApi = (stageId, payload) =>
  axiosInstance.post(`/stages/${stageId}/generate-from-group`, payload);